import * as React from 'react';
import { Select, CheckboxButton } from '@cian/ui-kit';
import * as style from './style.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var FiltersPanel = function FiltersPanel(_ref) {
  var houseId = _ref.houseId,
    sectionId = _ref.sectionId,
    housesOptions = _ref.housesOptions,
    sectionsOptions = _ref.sectionsOptions,
    roomTypesOptions = _ref.roomTypesOptions,
    onHouseChange = _ref.onHouseChange,
    onSectionChange = _ref.onSectionChange,
    onRoomTypesChange = _ref.onRoomTypesChange;
  return /*#__PURE__*/_jsxs("div", {
    className: style['container'],
    children: [/*#__PURE__*/_jsx("div", {
      className: style['select'],
      children: /*#__PURE__*/_jsx(Select, {
        disabled: !housesOptions.length,
        options: housesOptions,
        value: houseId,
        placeholder: "\u041A\u043E\u0440\u043F\u0443\u0441",
        onChange: onHouseChange
      })
    }), /*#__PURE__*/_jsx("div", {
      className: style['select'],
      children: /*#__PURE__*/_jsx(Select, {
        disabled: !sectionsOptions.length,
        options: sectionsOptions,
        value: sectionId,
        placeholder: "\u0421\u0435\u043A\u0446\u0438\u044F",
        onChange: onSectionChange
      })
    }), /*#__PURE__*/_jsx("div", {
      className: style['buttons-group'],
      children: roomTypesOptions.map(function (option) {
        return /*#__PURE__*/_jsx(CheckboxButton, {
          value: option.value,
          label: option.label,
          disabled: option.disabled,
          checked: option.checked,
          onChange: onRoomTypesChange(option.value)
        }, option.value);
      })
    })]
  });
};